import { Navigate, useLocation } from 'react-router-dom';

/** Sends a former flat accounting tab to its new home, carrying the query string (`?id=`, `?asAt=`) and hash with it. */
export default function LegacyRedirect({ to }: { to: string }) {
  const { search, hash } = useLocation();
  return <Navigate to={{ pathname: to, search, hash }} replace />;
}
